'use strict';

/**
 * Returns string values from a given array as space separated string to be
 * used as class names.
 * @param {array} classNames
 */
var arrToClassName = function arrToClassName(classNames) {
  return classNames.filter(function (className) {
    return className;
  }).join(' ');
};

/**
 * Returns a random item from a given array
 * @param {array} arr
 */
var randItem = function randItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
};

module.exports = {
  arrToClassName: arrToClassName,
  randItem: randItem
};